module.exports = __webpack_public_path__ + "static/img/pic_tysxx@2x.8146befc.png";